module.exports = __webpack_public_path__ + "static/media/react-new.ac02b66b.png";